export default __webpack_public_path__ + "static/media/systemHangersCover.c0756534.jpg";